var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        'cash-con': true,
        dark: !_vm.isLight,
        light: _vm.isLight,
    }},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_vm._v(" "),_c('loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }